import { ChevronRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { rememberMemoryReturnPath } from '../../../components/Chat/chat-handoff'
import { CHAT_MEMORY_PATH } from '../../../components/Chat/chat-route'
import { Button } from '../../../components/ui/button'
import { Card, CardContent } from '../../../components/ui/card'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '../../../components/ui/select'
import { Separator } from '../../../components/ui/separator'
import {
  OPERATOR_VIEW_OPTIONS,
  setOperatorView,
  useOperatorView,
  type OperatorView
} from '../../../lib/operator-view-flag'
import { ThemeModeToggle } from './ThemeModeCard'

/** Compact workspace rows for Settings → General (prototype tabs layout). */
export function WorkspaceCard() {
  const navigate = useNavigate()
  const operatorView = useOperatorView()

  return (
    <Card className="gap-0 overflow-hidden py-0 shadow-sm">
      <CardContent className="flex items-center justify-between gap-4 px-4 py-2.5">
        <div className="text-sm font-medium text-ink">Theme</div>
        <ThemeModeToggle />
      </CardContent>

      <Separator />

      <CardContent className="flex items-center justify-between gap-4 px-4 py-2.5">
        <div className="min-w-0">
          <div className="text-sm font-medium text-ink">Role view</div>
          <p className="text-xs text-ink-3">
            Changes the presentation only — permissions stay the same.
          </p>
        </div>
        <Select
          value={operatorView}
          onValueChange={(next) => setOperatorView(next as OperatorView)}
        >
          <SelectTrigger size="sm" aria-label="Role view" className="shrink-0">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {OPERATOR_VIEW_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </CardContent>

      <Separator />

      <Button
        type="button"
        variant="ghost"
        className="h-auto w-full justify-start gap-4 rounded-none px-4 py-2.5"
        onClick={() => {
          rememberMemoryReturnPath('/chat')
          navigate(CHAT_MEMORY_PATH)
        }}
      >
        <div className="min-w-0 flex-1 text-left">
          <div className="text-sm font-medium text-ink">Agent memory</div>
          <p className="text-xs font-normal text-ink-3">
            Shared reference every agent loads — conventions, acronyms, domain knowledge.
          </p>
        </div>
        <ChevronRight className="size-4 shrink-0 text-ink-3" />
      </Button>
    </Card>
  )
}
